import React from "react";
import { change, Field, formValueSelector, initialize, reduxForm } from "redux-form";
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from "react-intl";
import { Button } from "react-bootstrap";
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import ToolTipContent from "../../../Common/ToolTipContent/ToolTipContent";
import InputFieldComponent from "../../../Common/InputFieldComponent/InputFieldComponent";
import Loader from "../../../Common/Loader/Loader";

import { closeBaseFareModal } from "../../../../actions/siteadmin/modalActions";
import messages from "../../../../locale/messages";
import submit from "./submit";
import validate from "./validate";

import cs from '../../../commonStyle.css';
import s from './BaseFareForm.css';

const BaseFareForm = (props) => {
    const {
        closeBaseFareModal,
        handleSubmit,
        onSubmit,
        intl: { formatMessage },
        subCategoryName,
        pricingType,
        symbol,
        submitting,
        loading,
        categories,
        subCatgeoryChange
    } = props;

    const handleCancel = () => {
        closeBaseFareModal();
    };
    const handleFormSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(onSubmit)();
        subCatgeoryChange("ManageSubCategoryForm", "categories", categories);
    };

    return (
        <>
            <div className={s.baseFareFormText}>
                {formatMessage(messages.baseFareTitle)} {subCategoryName}
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className={cx(s.baseFareFormLabelTextContainer, 'svgImg')}>
                    {pricingType === 'fixed' ? (
                        <div className={s.baseFareFormLabelText}>
                            <span>{formatMessage(messages.baseFareLabel)}</span>
                            <span>{'('}<FormattedMessage {...messages.quantitlyLabel} />{')'}</span>
                        </div>
                    ) : (
                        <div className={s.baseFareFormLabelText}>
                            <span>{formatMessage(messages.baseFareLabel)}</span>
                            <span>{'('}<FormattedMessage {...messages.perHourLabel} />{')'}</span>
                        </div>
                    )}
                    <ToolTipContent label={formatMessage(messages.baseFareToolTipContent)} />
                </div>
                <Field
                    name="baseFare"
                    type="text"
                    component={InputFieldComponent}
                    inputClass={cs.formControlInput}
                    maxLength={6}
                    isAddon
                    suffixLabel={symbol}
                />
                <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                    <Button onClick={handleCancel} className={cs.btnSecondary}>
                        <FormattedMessage {...messages.cancelButton} />
                    </Button>
                    <Loader
                        type={"button"}
                        label={formatMessage(messages.update)}
                        show={loading}
                        buttonType={'submit'}
                        className={cx(cs.btnPrimary, 'loaderButtonFlex')}
                        disabled={submitting || loading}
                    />
                </div>
            </form>
        </>
    );
};

const selector = formValueSelector("BaseFareForm");

const mapState = (state) => ({
    subCategoryName: selector(state, "subCategoryName"),
    pricingType: selector(state, 'pricingType'),
    symbol: selector(state, 'symbol'),
    loading: state?.loader?.updateBasePrice
});

const mapDispatch = {
    closeBaseFareModal
};

const BaseFareFormWithReduxForm = reduxForm({
    form: 'BaseFareForm',
    onSubmit: submit,
    validate,
})(BaseFareForm);

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(BaseFareFormWithReduxForm)));